module.exports = __webpack_public_path__ + "static/media/IMG_1767.d9d966bf.jpg";